import React, { Component, Fragment } from "react";
import api from "../../../services/api";
import "./styles.css";
import ModalAlert from "../../common/modal-alert";
import ModalConfirm from "../../common/modal-confirm";

const formatDate = (dateString) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  
  if (isNaN(date.getTime())) return '';
  
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  
  return `${day}/${month}/${year}`;
};

class Company extends Component {
  state = {
    load: false,
    documentsToUpload: {},
    companyDocuments: {},
    showAprovacao: true,
    erroDelete: false,
    rejectDocument: false,
    expiredDocument: false,
    dataEmployee: {},
    employeeStatusId: "",
    msgFile: "",
    mounted: false
  };


  //TODO: Validate if the company fetch is right now it the 'businessUnit' feature, where and when  CompanyId is set?

  async componentDidMount() {
    this.setState({ mounted: true });
    await this.searchDataEmployee();
    await this.searchDocumentsEmployee();
    await this.searchDocumentsToEmployee();
  }

  componentWillUnmount() {
    this.setState({ mounted: false });
    // Clean up any resources or cancel any pending operations
  }

  searchDataEmployee = async () => {
    const dataEmployee = await api.get(
      `/employees?CompanyId=${localStorage.getItem("CompanyId")}`
    );

    if (dataEmployee.data.rows.length && this.state.mounted) {
      let employee = dataEmployee.data.rows.filter(
        e => e.id == this.props.match.params.id
      );
      this.setState({
        dataEmployee: employee[0],
        EmployeeStatus: employee[0].EmployeeStatus.description
      });
    }
  };

  searchDocumentsEmployee = async () => {
    if (this.state.dataEmployee && this.state.mounted) {
      const companyDocuments = await api.get(
        `/employees/${this.props.match.params.id}/attachments?DocumentTypeId=3`
      );
      this.setState({ companyDocuments: companyDocuments.data.rows });
    }
  };

  searchDocumentsToEmployee = async () => {
    if (!this.state.mounted) return;
    
    const functionId = this.state.dataEmployee.Function.id;

    const companyTypeDocuments = await api.get(
      `/company-types/${localStorage.getItem(
        "CompanyTypeId"
      )}/documents?DocumentTypeId=3&FunctionId=${functionId}`
    );
     
    if (this.state.mounted) {
      this.setState({ documentsToUpload: companyTypeDocuments.data.data });
      
      this.sendApproval();
      this.verifyStatusEmployee();
      this.verifyStatusDocuments();
      this.verifyIfHasDocumentExpired();
    }
  };

  verifyDocument = id => {
    const exist = this.state.companyDocuments.filter(
      item => item.DocumentId == id
    );
    return exist.length > 0 ? exist[0].originalName : "";
  };

  verifyDocumentNote = id => {
    const exist = this.state.companyDocuments.filter(
      item => item.DocumentId == id
    );
    return exist.length > 0 ? exist[0].note : "";
  };

  verifyIfHasDocumentExpired = () => {
    const exist = this.state.companyDocuments.filter(
      item => item.expired === true
    );
    if (exist.length > 0) {
      if (exist[0].expired) {
        this.setState({ expiredDocument: exist[0].expired });
      }
    }
  };

  verifyDocumentExpired = id => {
    const exist = this.state.companyDocuments.filter(
      item => item.DocumentId == id
    );
    if (exist.length > 0) {
      if (exist[0].expired) {
        return "Vencido";
      }
      else
      {
         return formatDate(exist[0].validityDate);
      }
    }
  };

  displayDateValidate = id => {

    const exist = this.state.companyDocuments.filter(
      item => item.DocumentId == id
    );

    console.dir(exist[0])
   
    if (exist.length > 0) {
      if (exist[0].expired) {
        return  (<i className="text-danger label label-light-danger m-l-20">Vencido {formatDate(exist[0].validityDate)}</i>);
      }
      if(!exist[0].expired && exist[0].validityDate!=null)
      {
        return  (<i className="text-success label label-light-success">{formatDate(exist[0].validityDate)}</i>);       
      }
    }
  };

  verifyDocumentApplicable = id => {
    const exist = this.state.companyDocuments.filter(
      item => item.DocumentId == id
    );

    if (exist.length > 0 && exist[0].notapplicable === true) {
      console.log("ta checkado");

      return true;
    }

    console.log("nao ta checkado");

    return false;
  };

  isExpired = id => {
    const exist = this.state.companyDocuments.filter(
      item => item.DocumentId === id
    );
    console.log("TCL: Company -> exist", exist);
    if (exist.length > 0) {
      return exist[0].expired;
    }
  };

  uploadDocument = async (e, id) => {
    // Status 4 : Rejeitado
    const rejectedDocument = this.state.companyDocuments.filter(
      item => item.AttachmentStatusId === 4
    );
    console.log(
      "========== DOCUMENTOS REJEITADOS ===========",
      rejectedDocument
    );
    if (e.target.files[0]) {
      this.setState({ msgFile: "", load: true });
      var nameFile = e.target.files[0].name.split(".");
      var nameFileTrat = nameFile[nameFile.length - 1];

      var arrayTypeFiles = [
        "txt",
        "pdf",
        "doc",
        "docx",
        "xlsx",
        "xls",
        "png",
        "jpg",
        "jpeg"
      ];
      var idx = arrayTypeFiles.indexOf(nameFileTrat);

      if (idx != -1) {
        const formData = new FormData();
        formData.append("attachment", e.target.files[0]);
        console.log(
          "TCL: Company -> uploadDocument ->  e.target.files[0]",
          e.target.files[0]
        );
        formData.append("DocumentId", e.target.id);
        formData.append("notapplicable", false);
        const config = {
          headers: {
            "content-type": "multipart/form-data"
          }
        };

        try {
          let response = null;
          if (
            rejectedDocument.length > 0 || this.isExpired(id)
              ? (response = await api.patch(
                  `/employees/${this.props.match.params.id}/newattachment`,
                  formData,
                  config
                ))
              : (response = await api.post(
                  `/employees/${this.props.match.params.id}/attachments`,
                  formData,
                  config
                ))
          )
            if (this.state.mounted) {
              this.setState({
                msgAlert: response.data.msg,
                classText: "text-success",
                load: false
              });
              document.getElementById("modal-alert").click();
              await this.searchDocumentsEmployee();
              await this.searchDocumentsToEmployee();
            }
        } catch (err) {
          if (!this.state.mounted) return;
          
          if (err && err.response.data.msg) {
            this.setState({
              msgAlert: err.response.data.msg,
              classText: "text-danger",
              load: false
            });
          } else {
            this.setState({
              msgAlert: "Erro no envio. Tente novamente!",
              classText: "text-danger",
              load: false
            });
          }
        }
      } else {
        if (this.state.mounted) {
          this.setState({
            msgFile:
              "Faça upload apenas as extensões: " +
              arrayTypeFiles.map(i => i + " ")
          });
        }
      }
    }
  };

  //Método para setar os documentos como não aplicáveis
  checkDocument = async e => {
    if (!this.state.mounted) return;
    
    this.setState({ msgFile: "", load: true });

    const data = {
      DocumentId: e.target.value,
      notapplicable:
        e.target.checked !== null && e.target.checked !== false ? true : false
    };

    await api
      .post(`/employees/${this.props.match.params.id}/attachments`, data)
      .then(async response => {
        if (!this.state.mounted) return;
        
        document.getElementById("modal-alert").click();
        this.setState({
          msgAlert: response.data.msg,
          classText: "text-success",
          load: false
        });
        await this.searchDocumentsEmployee();
        await this.searchDocumentsToEmployee();
      })
      .catch(err => {
        if (!this.state.mounted) return;
        
        if (err && err.response.data.errors[0]) {
          this.setState({
            msgAlert: err.response.data.errors[0].msg,
            classText: "text-danger"
          });
        } else {
          this.setState({
            msgAlert: "Erro no envio. Tente novamente!",
            classText: "text-danger"
          });
        }
      });
  };

  verifyDocumentIcon = id => {
    const exist = this.state.companyDocuments.filter(
      item => item.DocumentId == id
    );
    if (exist.length) {
      const status = exist[0].AttachmentStatusId;
      if (status == 1) {
        return "fa fa-clock-o";
      } else if (status == 2 && this.verifyDocumentExpired(id) !== "Vencido") {
        return "fa fa-check text-success";
      } else if (status == 4 || this.verifyDocumentExpired(id) === "Vencido") {
        return "fa fa-times text-danger";
      }
    } else {
      return "fa fa-circle-thin";
    }
  };

  sendApproval = () => {
    if (
      this.state.companyDocuments.length >= this.state.documentsToUpload.length
    ) {
      this.setState({ showAprovacao: true });
    } else {
      this.setState({ showAprovacao: false });
    }
  };

  verifyStatusEmployee = async e => {
    if (!this.state.mounted) return;
    
    await api.get(`/employees/${this.props.match.params.id}`).then(result => {
      if (this.state.mounted) {
        this.setState({ employeeStatusId: result.data.EmployeeStatusId });
      }
    });
  };

  alterEmployee = async () => {
    if (!this.state.mounted) return;
    
    await api.patch(`/employees/${this.props.match.params.id}`).then(result => {
      if (this.state.mounted) {
        this.setState({ dataEmployee: result.data.rows });
      }
    });
  };

  confirmAlterStatusEmployee = async e => {
    this.setState({ erroDelete: null });
    document.getElementById("modal-confirm").click();
  };

  alterStatusEmployee = async e => {
    if (!this.state.mounted) return;
    
    this.setState({ load: true });

    const ids = this.state.documentsToUpload.map(doc => doc.id);

    await api
      .patch(`/employees/${this.props.match.params.id}`, {
        EmployeeStatusId: 2,
        DocumentIds: ids
      })
      .then(result => {
        if (!this.state.mounted) return;
        
        document.getElementById("close-modal-confirm").click();
        document.getElementById("modal-alert").click();
        this.setState({ msgAlert: result.data.msg, classText: "text-success" });
        this.searchDocumentsEmployee();
        this.searchDocumentsToEmployee();
        this.searchDataEmployee();
        this.setState({ load: false, erroDelete: null });
      })
      .catch(err => {
        if (!this.state.mounted) return;
        
        if (err && err.response.data.errors[0]) {
          this.setState({
            msgAlert: err.response.data.errors[0].msg,
            classText: "text-danger",
            load: false
          });
        } else {
          this.setState({
            msgAlert: "Erro no envio. Tente novamente!",
            classText: "text-danger",
            load: false
          });
        }
      });
  };

  verifyStatusDocuments = () => {
    const exist = this.state.companyDocuments.filter(
      item => item.AttachmentStatusId == 4
    );
    this.setState({ rejectDocument: exist.length > 0 ? true : false });
  };
  /* 
     Status 1 = Envio de documentos - Não pode 
     Status 2 = Aprovação de documentos - Não pode
     Status 3 = Documentos rejeitados - Pode
     Status 4 = Pendente de integração - Não pode
     Status 5 = Habilitado - Pode* a não ser que já não tenha sido aprovado
     Status 6 = Desabilitado - Não pode
   */
  showFileButton = id =>
    (this.state.employeeStatusId === 3 || this.state.employeeStatusId === 1) &&
    this.verifyDocumentIcon(id) !== "fa fa-check text-success"
      ? true
      : false;

  // Para mostrar o botão de Enviar para aprovação
  showSubmitButtonByStatusCompany = () => {
    const {
      employeeStatusId,
      showAprovacao,
      rejectDocument,
      expiredDocument
    } = this.state;

    /**
     * Status 1 = Envio de documentos
     * Status 2 = Aprovação de documentos
     * Status 3 = Documentos da empresa rejeitados
     * Status 4 = Pendente de integração
     * Status 5 = Habilitado
     * Status 6 = Desativado
     * showAprovacao = Se todos os documentos cadastrais pendentes de envio já foram selecionados
     */
    if (employeeStatusId === 1 && showAprovacao) {
      console.log(
        "Status: Envio de documento e tem todos os docs selecionados"
      );
      return true;
    } else if (employeeStatusId === 3 && rejectDocument) {
      console.log(
        "Status: Documentos da empresa rejeitados, documentos ainda não foram substituidos e tem todos os docs selecionados"
      );
      return false;
    } else if (employeeStatusId === 2 || employeeStatusId === 4) {
      console.log(
        "Status: Aprovação de documentos do colaborador ou Pendente de integração"
      );
      return false;
    } else if (showAprovacao && employeeStatusId === 3 && !rejectDocument) {
      console.log(
        "Case: já não foi selecionado o documento e o status está como rejeitado"
      );
      return true;
    } else if (employeeStatusId === 5 && expiredDocument) return true;
  };
  render() {
    const { employeeStatusId } = this.state;

    return (
      <Fragment>
        <div className="row page-titles">
          <div className="col-md-5 col-8 align-self-center">
            <h3 className="text-themecolor">
              Documentos de Funcionário
              {this.state.load ? (
                <i className="fa fa-spin fa-spinner"></i>
              ) : null}
            </h3>
          </div>
        </div>

        <div className="row">
          <div className="m-b-10">
            <button
              onClick={() => this.props.history.goBack()}
              className="btn btn-rounded btn-outline-primary"
            >
              <i className="mdi mdi-arrow-left" />
            </button>
            {/* <a
              href="../../employees"
              className="btn btn-rounded btn-outline-primary"
            >
              <i className="mdi mdi-arrow-left"></i>
            </a> */}
          </div>
          <div className="col-md-12 alert alert-primary">
            <span>
              Status da empresa:
              <strong> {localStorage.getItem("companyStatus")}</strong>
            </span>
          </div>
          <div className="col-md-12 alert alert-primary">
            <span>
              Status do funcionário {this.state.dataEmployee.name}:
              <strong> {this.state.EmployeeStatus}</strong>
            </span>
          </div>
        </div>

        <form action="javascript:void(0)" id="formDocuments">
          <div className="row m-b-15">
            <div className="col-md-12">
              <fieldset>
                <div className="row detail-company">
                  <div className="col-md-4 p-10">
                    <strong className="text-primary p-10">Nome:</strong>
                    <span>{this.state.dataEmployee.name}</span>
                  </div>
                  <div className="col-md-5 p-10">
                    <strong className="text-primary p-10">Email:</strong>
                    <span>{this.state.dataEmployee.email}</span>
                  </div>
                  <div className="col-md-3 p-10">
                    <strong className="text-primary p-10">Setor:</strong>
                    {this.state.dataEmployee.Sector ? (
                      <span>{this.state.dataEmployee.Sector.name}</span>
                    ) : null}
                  </div>
                  <div className="col-md-4 p-10">
                    <strong className="text-primary p-10">Telefone:</strong>
                    <span>{this.state.dataEmployee.phone}</span>
                  </div>
                  <div className="col-md-4 p-10">
                    <strong className="text-primary p-10">CPF:</strong>
                    <span>{this.state.dataEmployee.cpf}</span>
                  </div>
                  <div className="col-md-4 p-10">
                    <strong className="text-primary p-10">RG:</strong>
                    <span>{this.state.dataEmployee.rg}</span>
                  </div>
                  <div className="col-md-4 p-10">
                    <strong className="text-primary p-10">Estado:</strong>
                    <span>{this.state.dataEmployee.state}</span>
                  </div>
                  <div className="col-md-4 p-10">
                    <strong className="text-primary p-10">Cidade:</strong>
                    <span>{this.state.dataEmployee.city}</span>
                  </div>
                  <div className="col-md-4 p-10">
                    <strong className="text-primary p-10">Bairro:</strong>
                    <span>{this.state.dataEmployee.district}</span>
                  </div>
                  <div className="col-md-8 p-10">
                    <strong className="text-primary p-10">Endereço:</strong>
                    <span>{this.state.dataEmployee.address}</span>
                  </div>
                  <div className="col-md-4 p-10">
                    <strong className="text-primary p-10">Número:</strong>
                    <span>{this.state.dataEmployee.number}</span>
                  </div>
                  <div className="col-md-12 p-10">
                    <strong className="text-primary p-10">Complemento:</strong>
                    <span>{this.state.dataEmployee.complement}</span>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>

          <div className="row card">
            <div className="col-md-12">
              <div className="card-body">
                <h4 className="card-title">
                  Envio de documentos do funcionário para credenciamento da
                  empresa
                </h4>

                <div className="feeds" style={{ overflowX: "hidden" }}>
                  {this.state.documentsToUpload.length
                    ? this.state.documentsToUpload.map(item => {
                        return (
                          <div
                            key={item.id}
                            className="row"
                            style={{ padding: "37px" }}
                          >
                            <i className={this.verifyDocumentIcon(item.id)}></i>
                            <div className="col-md-3">{item.description}</div>
                            <div className="col-md-2">
                              {this.verifyDocumentNote(item.id) ? (
                                <i className="text-danger label label-light-danger m-l-20">
                                  {this.verifyDocumentNote(item.id)}
                                </i>
                              ) : null}
                            
                              {this.displayDateValidate(item.id)}                             

                            </div>
                            <div className="col-md-2">
                              {this.verifyDocument(item.id) ? (
                                <i
                                  alt={this.verifyDocument(item.id)}
                                  title={this.verifyDocument(item.id)}
                                  className={
                                    this.verifyDocument(item.id)
                                      ? "text-success label label-light-success"
                                      : "text-danger"
                                  }
                                >
                                  <i className="fa fa-check"></i>
                                  {this.verifyDocument(item.id).substr(0, 20) +
                                    "..."}
                                </i>
                              ) : null}
                            </div>

                            <div className="col-md-2">
                              {/* Se status = ("Envio de documentos da empresa" ou
                              "Documentos da empresa rejeitados") e 
                              Não tiver sido aprovado então renderiza o botão */}
                              {/* {employeeStatusId === 1 ||
                              (employeeStatusId === 3 &&
                                this.verifyDocumentIcon(item.id) !==
                                  "fa fa-check text-success") ? ( */}
                              {this.verifyDocumentExpired(item.id) ===
                                "Vencido" ||
                              (this.showFileButton(item.id) &&
                                this.verifyDocumentApplicable(item.id) ==
                                  false) ? (
                                <input
                                  type="file"
                                  style={{ width: "150px" }}
                                  id={item.id}
                                  onChange={e =>
                                    this.uploadDocument(e, item.id)
                                  }
                                />
                              ) : null}
                            </div>

                            <div className="col-md-2">
                              {employeeStatusId !== 2 &&
                              employeeStatusId !== 4 &&
                              employeeStatusId !== 5 &&
                              this.verifyDocumentIcon(item.id) !==
                                "fa fa-check text-success" ? (
                                <div key={item.id} className="text-right p-10">
                                  <input
                                    type="checkbox"
                                    checked={this.verifyDocumentApplicable(
                                      item.id
                                    )}
                                    name="not_applicable"
                                    value={item.id}
                                    id={"document_" + item.id}
                                    onClick={e => this.checkDocument(e)}
                                  />
                                  <label htmlFor={"document_" + item.id}>
                                    {" "}
                                    Não Aplicável{" "}
                                  </label>
                                </div>
                              ) : null}
                            </div>
                          </div>
                        );
                      })
                    : null}
                </div>
              </div>
            </div>
            <div className="col-md-12 text-center p-20">
              {/* {this.state.documentsToUpload.length &&
                this.state.showAprovacao &&
                (this.state.EmployeeStatus == 1 ||
                  this.state.EmployeeStatus == 3) && ( */}
              {this.showSubmitButtonByStatusCompany() ? (
                <button
                  className="btn btn-success"
                  onClick={this.confirmAlterStatusEmployee}
                >
                  Enviar para aprovação
                </button>
              ) : null}

              {this.state.msgFile ? (
                <div className="alert alert-danger">{this.state.msgFile}</div>
              ) : null}

              {!this.state.showAprovacao &&
                (this.state.employeeStatusId == 1 ||
                  this.state.employeeStatusId == 3) && (
                  <div className="alert alert-danger">
                    Para enviar os documentos para aprovação é necessário anexar
                    todos os documentos!
                  </div>
                )}

              {this.state.employeeStatusId == 2 && (
                <div className="alert alert-info">
                  Documentos estão em processo de aprovação!
                </div>
              )}
            </div>
          </div>
        </form>

        <ModalConfirm
          title="Confirmação"
          msg="Tem certeza que deseja enviar os documentos do colaborador para aprovação?"
          load={this.state.load}
          function={this.alterStatusEmployee}
          msgError={this.state.erroDelete}
        />
        <ModalAlert
          title="Envio de Documento(s)"
          msg={this.state.msgAlert}
          function=""
          classText={this.state.classText}
        />
      </Fragment>
    );
  }
}

export default Company;
